import { Quiz } from "@components/Quiz";

export const Home = () => (
  <div className="row">
    <Quiz />
  </div>
);
